import React, { PureComponent } from 'react';
import { bool, func, string, shape, arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { formValueSelector, reduxForm } from 'redux-form';
import DOMPurify from 'dompurify';
import { addTargetBlankToSelector } from '@widergy/web-utils/lib/dom';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTButton } from '@widergy/energy-ui';

import { ROUTES } from 'constants/routes';

import { actionCreators as accountActions } from '../../../../../redux/accountHandlers';
import { DIGITAL_BILL_FORM } from '../../../../../constants/general';
import { SIGNUP_SERVICE_ADHERENCE } from '../../../../../constants/reduxForms';
import AuthFormBox from '../../../../components/AuthFormBox';
import { message } from '../../../../../utils/stringUtils';
import ReturnToSignIn from '../ReturnToSignIn';
import { gaTrackPageView } from '../../../../../services/AnalyticsService';

import ServiceAdherence from './layout';
import styles from './styles';

const ACCOUNT_LIST = 'accountList';

class ServiceAdherenceContainer extends PureComponent {
  componentDidMount = () => {
    this.props.dispatch(accountActions.getTermsOfService(DIGITAL_BILL_FORM));
    gaTrackPageView(ROUTES.SIGN_UP);
  };

  componentDidUpdate() {
    addTargetBlankToSelector('a');
  }

  createHtml = htmlInput => ({ __html: DOMPurify.sanitize(htmlInput) });

  handleCheckTerms = () => this.setState({ acceptedTerms: !this.state.acceptedTerms });

  render() {
    return (
      <form
        onSubmit={this.props.handleSubmit}
        onKeyDown={handleKeyDown(this.props.handleSubmit)}
        style={styles.container}
      >
        <AuthFormBox title={message('Signup:serviceAdherence')}>
          <ServiceAdherence
            loading={this.props.loading}
            termsOfService={this.createHtml(this.props.termsOfService)}
            accounts={this.props.accounts}
          />
        </AuthFormBox>
        {!this.props.loading && (
          <React.Fragment>
            <UTButton
              disabled={this.props.submitFailed && this.props.invalid}
              style={styles.submit}
              type="submit"
            >
              {this.props.accountList && this.props.accountList.length > 0
                ? message('Commons:accept')
                : message('Signup:next')}
            </UTButton>
            <ReturnToSignIn />
          </React.Fragment>
        )}
      </form>
    );
  }
}

export const accountsPropTypes = arrayOf(
  shape({
    id: string,
    client_number: string,
    address: string
  })
);

ServiceAdherenceContainer.propTypes = {
  loading: bool,
  termsOfService: string,
  accountList: accountsPropTypes,
  accounts: accountsPropTypes,
  handleSubmit: func.isRequired,
  submitFailed: bool,
  invalid: bool
};

const stepSelector = (_, props) => props.stepNumber === 8;

const initialAccountSelector = (store, props) =>
  props.initialAccount || (store.account.currentAccount && store.account.currentAccount.client_number);

export const accountsSelector = createSelector(
  store => store.account.accounts,
  initialAccountSelector,
  stepSelector,
  (accounts, initialAccount, firstAccountStep) => {
    const accountList = firstAccountStep
      ? accounts.filter(account => account.client_number === initialAccount)
      : accounts.filter(account => account.client_number !== initialAccount);
    return accountList.map(account => ({
      id: account.client_number,
      client_number: account.client_number,
      address: account.address
    }));
  }
);

const formSelector = formValueSelector(SIGNUP_SERVICE_ADHERENCE);

const mapStateToProps = (store, props) => ({
  termsOfService: store.account.termsOfService,
  loading:
    store.account.termsOfServiceLoading ||
    store.account.accountsLoading ||
    store.account.acceptServiceAgreementLoading,
  accounts: accountsSelector(store, props),
  accountList: formSelector(store, ACCOUNT_LIST)
});

const form = reduxForm({ form: SIGNUP_SERVICE_ADHERENCE })(ServiceAdherenceContainer);

export default connect(mapStateToProps)(form);
